import React from 'react';
import { Spin } from 'antd';

const spinner = () => {
    return ( <Spin size="large" tip="Loading..."/>)
}

export default spinner;